module.exports = __webpack_public_path__ + "static/img/leftArrow.8965662a.png";